import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createAppPreAsyncThunk } from '../../../../common/thunk';
import UserService from '../../../../services/user.service';
import { UserRole } from '../../../../common/enums/UserRole';
import { User } from '../../../../types/User';

interface AdministratorsState {
  administrators: Array<User>;
  isAdminInvited: boolean;
  roles: Array<string>;
}

const initialState: AdministratorsState = {
  administrators: [],
  isAdminInvited: false,
  roles: [],
};

export const getAdministrators = createAppPreAsyncThunk('administrators', async () => {
  return await UserService.getUsers({ role: UserRole.ADMIN }).then(response => response.data);
});

export const deleteAdministrator = createAppPreAsyncThunk('administrators/delete', async id => {
  return await UserService.deleteUser(id).then(response => response.data);
});

export const createAdministrator = createAppPreAsyncThunk('administrators/create', async data => {
  return await UserService.createUser(data).then(response => response.data);
});

export const getRoles = createAppPreAsyncThunk('roles/get', async () => {
  return await UserService.getUserRoles().then(response => response.data);
});

const setUsers = (state: AdministratorsState, action: PayloadAction<Array<User>>) => {
  state.administrators = action.payload;
};

const filterDeletedAdministrator = (state: AdministratorsState, action: PayloadAction<{ deleted: string }>) => {
  state.administrators = state.administrators.filter(item => item.id !== action.payload.deleted);
};

const setRoles = (state: AdministratorsState, action: PayloadAction<{ roles: Array<string> }>) => {
  state.roles = action.payload.roles;
};

export const administratorsSlice = createSlice({
  name: 'administrators',
  initialState,
  reducers: {
    setIsAdminInvited: (state, action: PayloadAction<boolean>) => {
      state.isAdminInvited = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getAdministrators.fulfilled, setUsers);
    builder.addCase(deleteAdministrator.fulfilled, filterDeletedAdministrator);
    builder.addCase(createAdministrator.fulfilled, state => {
      state.isAdminInvited = true;
    });
    builder.addCase(getRoles.fulfilled, setRoles);
  },
});
export const { setIsAdminInvited } = administratorsSlice.actions;
export default administratorsSlice.reducer;
